/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Replace_ListsInputs */



/**
* | output |
* | --- |
* | "Auto Replace Lists" |
*
* @param {Auto_Replace_ListsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_replace_lists = /** @type {((inputs?: Auto_Replace_ListsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Replace_ListsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Listes de remplacement automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Ersetzungslisten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elenchi di sostituzione automatica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Списки автоматической замены")
	if (locale === "es") return /** @type {LocalizedString} */ ("Listas de reemplazo automático")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动替换列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動置換リスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटो रिप्लेस सूचियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Listas de Substituição Automática")
	return /** @type {LocalizedString} */ ("Auto Replace Lists")
});